import { api } from '../../utils';

class ModuleApi {
  getTenants() {
    return api.get('/tenants');
  }

  addTenant(data) {
    return api.post('/tenants', data);
  }

  editTenant(id, data) {
    return api.put(`/tenants/${id}`, data);
  }

  deleteTenant(id) {
    return api.delete(`/tenants/${id}`);
  }

  getSubtenants(tenantId?) {
    return api.get(`/subtenants/?tenant=${tenantId}`);
  }

  addSubTenant(data) {
    return api.post('/subtenants', data);
  }

  editSubTenant(id, data) {
    return api.put(`/subtenants/${id}`, data);
  }

  deleteSubTenant(id) {
    return api.delete(`/subtenants/${id}`);
  }
}

export default new ModuleApi();
